"use strict";
import Navbar from "components/NavBar/index";
import { useScroll } from "hooks/useScroll";
import { GRID_AREAS } from "pages/App/utils/shared";
import { memo } from "react";
import { Flex } from "ui/src";
import { zIndexes } from "ui/src/theme";
export const Header = memo(function Header2() {
  const { isScrolledDown } = useScroll();
  const isHeaderTransparent = !isScrolledDown;
  return <Flex
    id="AppHeader"
    $platform-web={{
      gridArea: GRID_AREAS.HEADER,
      position: "sticky"
    }}
    className="webkitSticky"
    width="100vw"
    top={0}
    zIndex={zIndexes.dropdown}
    pointerEvents="none"
  >
      <style>
        {`
          .webkitSticky {
            position: -webkit-sticky;
          }
        `}
      </style>
      {
    /* <Flex position="relative" zIndex={zIndexes.sticky} pointerEvents="auto">
      {extensionEligible && <MobileAppPromoBanner />}
      {renderUkBanner && <UkBanner />}
    </Flex> */
  }
      <Flex
    width="100%"
    backgroundColor={isHeaderTransparent ? "transparent" : "$surface1"}
    borderBottomColor={isHeaderTransparent ? "transparent" : "$accent2Hovered"}
    borderBottomWidth={1}
    pointerEvents="auto"
    $platform-web={{
      backdropFilter: isHeaderTransparent ? "none" : "saturate(180%) blur(18px)",
      WebkitBackdropFilter: isHeaderTransparent ? "none" : "saturate(180%) blur(18px)",
      transition: "background-color 220ms ease, backdrop-filter 220ms ease, border-color 220ms ease",
      boxShadow: isHeaderTransparent ? "none" : "0 8px 30px -20px rgba(0, 0, 0, 0.5)"
    }}
  >
        <Navbar />
      </Flex>
    </Flex>;
});
